const SET_IS_FETCHING = 'loginPodcastNetworkScreen/SET_IS_FETCHING';
const SET_STATIONS = 'loginPodcastNetworkScreen/SET_STATIONS';

export default {
  SET_STATIONS,
  SET_IS_FETCHING,
};
